import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { api } from '@/lib/api';
import { useAuth } from '@/context/AuthContext';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = location.hash || '';
    const params = new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash);
    const sid = params.get('session_id');
    if (!sid) { nav('/login'); return; }
    (async () => {
      try {
        const { data } = await api.post('/auth/session', { session_id: sid });
        setUser(data);
        window.history.replaceState(null, '', '/dashboard');
        nav('/dashboard', { replace: true });
      } catch {
        nav('/login', { replace: true });
      }
    })();
  }, [location.hash, nav, setUser]);

  return <div className="p-20 text-center text-muted-foreground">Accesso in corso…</div>;
}
